import { useQuery } from 'react-query'
import axios from 'lib/axiosConfigWithoutHumps'
import { PlaceRequest } from 'types/api/place'
import { useMemo } from 'react'

export const useExtData = (placeId: string) => {
  const {
    isLoading,
    error,
    data: response,
  } = useQuery(['getExtData', placeId], async () =>
    axios.get(`/v1/places/${placeId}`)
  )
  const data = useMemo(() => {
    const place: PlaceRequest = response?.data.data
    return {
      externalData: place?.external_data,
      name: place?.name,
      masterId: place?.master_id,
    }
  }, [response])

  return { isLoading, error, data }
}
